<button class="panel__header" (click)="toggle()">
    <div class="panel__icon">
        <ng-content select="[icon]"></ng-content>
    </div>
    <p class="panel__title">
        <ng-content select="[title]"></ng-content>
    </p>
    <i icon class="panel__arrow fas" [ngClass]="{
        'fa-chevron-down': !opened,
        'fa-chevron-up': opened
    }"></i>
</button>
<div class="panel__content">
    <ng-content></ng-content>
</div>
